// extracted by mini-css-extract-plugin
export var activeFilterButton = "_r0-c";
export var backButton = "_r0-4";
export var backIcon = "_r0-5";
export var chevronShortcut = "_r0-6";
export var container = "_r0-1";
export var editor = "_r0-8";
export var editorWrapper = "_r0-7";
export var prefix = "_r0-2";
export var searchIcon = "_r0-3";
export var suffix = "_r0-9";
export var suffixContent = "_r0-a";
export var suffixText = "_r0-b";
export var wrapper = "_r0-0";